export const TenantPropertyTypes = {
  LOAD_TENANT_PROPERTY: 'LOAD_TENANT_PROPERTY',
  LOAD_TENANT_PROPERTIES: 'LOAD_TENANT_PROPERTIES',
}
